// src/components/SplashScreen.jsx

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/HCO-Logo.png";
import { motion, AnimatePresence } from "framer-motion";

export default function SplashScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/login");
    }, 10000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-gray-100 flex items-center justify-center relative overflow-hidden">
      {/* Animated Background Blobs */}
      <motion.div
        className="absolute -top-20 -left-20 w-72 h-72 bg-orange-300 rounded-full filter blur-2xl opacity-20"
        animate={{ scale: [1, 1.2, 1], x: [0, 10, 0], y: [0, -10, 0] }}
        transition={{ duration: 6, repeat: Infinity }}
      />

      <motion.div
        className="absolute -bottom-24 -right-24 w-80 h-80 bg-yellow-300 rounded-full filter blur-2xl opacity-10"
        animate={{ scale: [1, 1.1, 1], x: [0, -10, 0], y: [0, 10, 0] }}
        transition={{ duration: 5, repeat: Infinity }}
      />

      {/* Spinning Logo and Text */}
      <motion.div
        className="flex flex-col items-center text-center z-10"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <motion.img
          src={logo}
          alt="Logo"
          className="h-20 md:h-24 mb-6 drop-shadow-lg"
          // animate={{ rotate: [0, 10, -10, 0] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        />

        <motion.h1
          className="text-orange-600 text-3xl md:text-4xl font-bold tracking-tight drop-shadow"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          Hold the Child Data Management
        </motion.h1>

        <motion.p
          className="text-orange-500 mt-4 text-sm md:text-base drop-shadow"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2, duration: 1 }}
        >
          Digital and automated data for Hold The Child Organization.
        </motion.p>

        <motion.div
          className="flex space-x-1 mt-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 2, duration: 1 }}
        >
          {[...Array(5)].map((_, i) => (
            <motion.div
              key={i}
              className={`w-2 h-2 rounded-full ${i === 2 ? "bg-orange-500" : "bg-orange-300"}`}
              animate={{ scale: [1, 1.3, 1] }}
              transition={{ duration: 1.5, repeat: Infinity, delay: i * 0.2 }}
            />
          ))}
        </motion.div>

        <motion.div
          className="mt-10 w-48 h-1 rounded-full bg-orange-200"
          animate={{ width: ["0%", "100%"] }}
          transition={{ duration: 3.5, ease: "easeInOut" }}
        />
      </motion.div>
    </div>
  );
}
